module.exports = __webpack_public_path__ + "img/two_men.a4fbec9e.svg";